import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useLocale } from '../contexts/LocaleContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLocale();
  const year = new Date().getFullYear();

  const links = [
    { to: '/', label: t.nav.home, end: true },
    { to: '/streams', label: t.nav.streams },
    { to: '/news', label: t.nav.news }
    // Scores temporarily hidden
  ];

  return (
    <footer className="lf-ft">
      <div className="lf-ft__inner">
        <div className="lf-ft__row">
          <Link to="/" className="lf-ft__brand" aria-label={t.brand}>
            <img src="/logo-wordmark.webp?v=2" alt="Live Football" />
          </Link>

          <nav className="lf-ft__nav" aria-label="Footer">
            {links.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => (isActive ? 'is-active' : undefined)}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="lf-ft__rule" aria-hidden="true" />

        <div className="lf-ft__meta">
          <p>© {year} livefootball.space</p>
          <p className="lf-ft__tag">{t.home?.heroText}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
